export default __webpack_public_path__ + "static/media/keynote12.3c08b4d7.jpeg";